import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";
import { useGalleryBannerContext } from "../context/GalleryBannerContext";
import { useGalleryImageContext } from "../context/GalleryImageContext";
import { dynamicFailed } from "../hooks/useToast";
import { fetchGalleryBanner, fetchGalleryData } from "../api/GalleryApi";
import GalleryBanner from "../components/gallery/GalleryBanner";
import Album from "../components/gallery/Album";
import { useEventContext } from "../context/EventContext";
import { fetchEventData } from "../api/EventApi";

const Gallery = () => {
  const { setLoading } = useLoader();
  const { galleryBannerData, setGalleryBannerData } = useGalleryBannerContext();
  const { galleryImageData, setGalleryImageData } = useGalleryImageContext();
  const { eventData, setEventData } = useEventContext();

  useEffect(() => {
    setLoading(true);
    if (
      galleryBannerData.length === 0 ||
      galleryImageData.length === 0 ||
      eventData.length === 0
    ) {
      Promise.all([fetchGalleryData(), fetchGalleryBanner(), fetchEventData()])
        .then(([galleryData, galleryBannerData, eventData]) => {
          setGalleryImageData(galleryData);
          setGalleryBannerData(galleryBannerData);
          setEventData(eventData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          dynamicFailed("Server Error");
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [
    eventData.length,
    galleryBannerData.length,
    galleryImageData.length,
    setEventData,
    setGalleryBannerData,
    setGalleryImageData,
    setLoading,
  ]);
  return (
    <>
      <GalleryBanner galleryBannerData={galleryBannerData} />
      <Album galleryImageData={galleryImageData} eventData={eventData}/>
    </>
  );
};

export default Gallery;
